export const PENDING  = 'PENDING';
export const ANSWERED = 'ANSWERED';
export const EXPIRED  = 'EXPIRED';
